import React, { useState, useEffect } from 'react';

const links = [
  { id: 'home', label: 'Home' },
  { id: 'about', label: 'About' },
  { id: 'work-history', label: 'Experience' },
  { id: 'projects', label: 'Projects' },
  { id: 'contact', label: 'Contact' },
];

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [progress, setProgress] = useState(0);
  const [activeId, setActiveId] = useState('home');

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY;
      setScrolled(y > 20);
      const max = document.documentElement.scrollHeight - window.innerHeight;
      setProgress(max > 0 ? Math.min(100, (y / max) * 100) : 0);

      const fromTop = y + window.innerHeight * 0.35;
      let current = 'home';
      for (const { id } of links) {
        const el = document.getElementById(id);
        if (el && el.offsetTop <= fromTop) current = id;
      }
      setActiveId(current);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const toggleMenu = () => setIsOpen((o) => !o);

  const handleScroll = (event, targetId) => {
    event.preventDefault();
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth' });
      setIsOpen(false);
    }
  };

  return (
    <div className="w-full">
      <nav
        className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
          scrolled
            ? 'bg-bg/85 backdrop-blur-md border-b border-line'
            : 'bg-transparent border-b border-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <a
              href="#home"
              onClick={(e) => handleScroll(e, 'home')}
              className="group"
            >
              <span className="text-ink font-display font-bold text-xl tracking-tight group-hover:text-accent transition-colors duration-300">
                Sooraj<span className="text-accent">.</span>
              </span>
            </a>

            <div className="hidden md:flex items-center gap-1">
              {links.map(({ id, label }) => (
                <a
                  key={id}
                  href={`#${id}`}
                  onClick={(e) => handleScroll(e, id)}
                  className={`relative px-4 py-2 text-sm transition-colors duration-300 ${
                    activeId === id
                      ? 'text-accent'
                      : 'text-ink-muted hover:text-ink'
                  }`}
                >
                  {label}
                  {activeId === id && (
                    <span className="absolute left-4 right-4 -bottom-0.5 h-px bg-accent" />
                  )}
                </a>
              ))}
            </div>

            <div className="-mr-2 flex md:hidden">
              <button
                onClick={toggleMenu}
                aria-label="Toggle menu"
                className="p-2 border border-line text-ink hover:border-accent hover:text-accent transition-colors"
              >
                <svg className="h-5 w-5" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                  {isOpen ? (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                  ) : (
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7" />
                  )}
                </svg>
              </button>
            </div>
          </div>
        </div>

        <div className="relative h-px w-full bg-line">
          <div
            className="absolute left-0 top-0 h-px bg-accent shadow-glow"
            style={{ width: `${progress}%` }}
          />
        </div>

        {isOpen && (
          <div className="md:hidden animate-fade-in bg-bg border-t border-line">
            <div className="px-4 py-4 space-y-1">
              {links.map(({ id, label }) => (
                <a
                  key={id}
                  href={`#${id}`}
                  onClick={(e) => handleScroll(e, id)}
                  className={`flex items-center justify-between px-3 py-3 text-sm transition-colors ${
                    activeId === id
                      ? 'text-accent bg-surface'
                      : 'text-ink-muted hover:text-ink hover:bg-surface'
                  }`}
                >
                  <span>{label}</span>
                  <span className="text-ink-dim">→</span>
                </a>
              ))}
            </div>
          </div>
        )}
      </nav>
    </div>
  );
};

export default Navbar;
